<template>
  <header class="header-unauthenticated">
    <div class="container">
      <div @click="goBack">
        <img src="@/assets/chevron.svg" alt="">
      </div>
    </div>
  </header>
</template>

<script>
export default {
  methods: {
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style lang="scss">
@import '@/styles/_variables';

.header-unauthenticated {
  height: 48px;
  width: 100%;
  position: fixed;
  top: 0;
  color: $white;
  background: none;
  padding: 0;
  cursor: pointer;

  img {
    padding: $margin-base;
  }
}
</style>